// extracted by mini-css-extract-plugin
export default {"originalTextRow":"PyYoKVFifzMygF7hTHgZ"};